export default class GetCountriesModel {
  constructor({ code, label } = {}) {
    this.code = code || null;
    this.label = label || null;
  }
}
